import { CalendarDots, Car, FileText, Gift, House, Airplane, Shield, Umbrella, Wrench } from '@phosphor-icons/react';

/** Presets do mockup «Calendário Anual completo» — ocasionais comuns em PT. */
export const ANNUAL_OCCASIONAL_SUGGESTIONS = [
  {
    id: 'iuc',
    name: 'IUC',
    description: 'imposto do carro · maio',
    month: 5,
    budget_allocation: 'essential',
    icon: Car,
  },
  {
    id: 'imi',
    name: 'IMI',
    description: 'imposto da casa · abr/nov',
    month: 4,
    budget_allocation: 'essential',
    icon: House,
  },
  {
    id: 'irs',
    name: 'IRS',
    description: 'acerto · verão',
    month: 7,
    budget_allocation: 'essential',
    icon: FileText,
  },
  {
    id: 'car-insurance',
    name: 'Seguro automóvel',
    description: 'renovação anual',
    month: 5,
    budget_allocation: 'essential',
    icon: Car,
  },
  {
    id: 'home-insurance',
    name: 'Seguro de casa',
    description: 'renovação anual',
    month: 9,
    budget_allocation: 'essential',
    icon: Shield,
  },
  {
    id: 'holidays',
    name: 'Férias',
    description: 'verão',
    month: 7,
    budget_allocation: 'lifestyle',
    icon: Airplane,
  },
  {
    id: 'christmas',
    name: 'Natal',
    description: 'dezembro',
    month: 12,
    budget_allocation: 'lifestyle',
    icon: Gift,
  },
];

const NAME_ICON_RULES = [
  { match: /inspe[cç][aã]o/i, icon: Wrench },
  { match: /iuc|autom[oó]vel|carro|revis[aã]o/i, icon: Car },
  { match: /imi|casa|habit/i, icon: House },
  { match: /irs|imposto/i, icon: FileText },
  { match: /seguro/i, icon: Shield },
  { match: /f[eé]rias|viagem|viagens/i, icon: Airplane },
  { match: /natal|pr[eé]sent/i, icon: Gift },
];

/**
 * Resolve a Lucide icon for a duty card from suggestion presets or name keywords.
 */
export function resolveOccasionalIcon(item) {
  const name = String(item?.name || '').trim();
  if (!name) return CalendarDots;

  const fromSuggestion = ANNUAL_OCCASIONAL_SUGGESTIONS.find(
    (suggestion) => suggestion.name.toLowerCase() === name.toLowerCase(),
  );
  if (fromSuggestion) return fromSuggestion.icon;

  for (const rule of NAME_ICON_RULES) {
    if (rule.match.test(name)) return rule.icon;
  }

  if (item?.budget_allocation === 'lifestyle') return Umbrella;
  return CalendarDots;
}

export function suggestionToFormInitial(suggestion, viewYear) {
  return {
    name: suggestion.name,
    month: suggestion.month,
    budget_allocation: suggestion.budget_allocation,
    target_year: viewYear,
    create_smoothing_pot: true,
  };
}
